export const TOGGLE_ADD_ACCOUNT_SUCCESS = 'TOGGLE_ADD_ACCOUNT_SUCCESS';
export const TOGGLE_DELETE_ACCOUNT_SUCCESS = 'TOGGLE_DELETE_ACCOUNT_SUCCESS';
export const SHOW_ACCOUNT_LIST = 'SHOW_ACCOUNT_LIST';